
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pencarian",
      function () {
        return require("private-next-pages/pencarian/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pencarian"])
      });
    }
  